import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, Optional, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TaxReturnService } from '../../../../../swaggerServices/api/api';
import { ITaxReturn } from '../../../../app/tax-returns/tax-return/model/i-tax-return';
import { UserInfoService } from '../../../../app/user-info.service';
import { ConfigStateService } from '../../../../app/config/config-state.service';
import { Tenant } from '../../../types/tenant.enum';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TenantConfigService } from '../../../services/tenant-config.service';
import { TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'amend-confirmation',
    templateUrl: './amend-confirmation.component.html',
    styleUrls: ['./amend-confirmation.component.scss'],
    standalone: false
})
export class AmendConfirmationComponent implements OnInit, OnDestroy {
  taxReturn: ITaxReturn;
  @Output() closed = new EventEmitter();
  @Output() completed = new EventEmitter();
  @Output() wrongPermission = new EventEmitter<string>();
  showModal: boolean = false;
  showChangeReason: boolean = true;
  uiConfig: TenantConfigService;
  subscriptions: Subscription[] = [];
  taxReturnAlias: string;

  dialogData: { taxReturn: ITaxReturn } = inject(MAT_DIALOG_DATA);

  private unsubscribe: Subject<void> = new Subject();
  constructor(
    private taxReturnService: TaxReturnService,
    private userInfo: UserInfoService,
    private configStateService: ConfigStateService,
    private translocoService: TranslocoService,
    @Optional() private dialogRef?: MatDialogRef<AmendConfirmationComponent>
    ) {
      this.taxReturn = this.dialogData.taxReturn;
    }

  ngOnInit() {
    if (this.isAssignedToMe()) {
      this.completed.emit();
    } else if (!this.hasPermission()) {
      this.wrongPermission.emit('YouWerePreparer');
      this.closed.emit();
    } else {
      this.showModal = true;
      this.showChangeReason = (this.configStateService.config.tenant === Tenant.SG || this.configStateService.config.tenant === Tenant.HK || this.configStateService.config.tenant === Tenant.CN)
    }
    this.subscriptions.push(
      this.configStateService.loadConfig().subscribe(configStateService => {
        this.uiConfig = new TenantConfigService(configStateService);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias;
        this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
      })
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.subscriptions.forEach(s => s.unsubscribe());

  }

  processTaxReturn(amendmentCount) {
    const count = (amendmentCount && amendmentCount.changeCount) ? amendmentCount.changeCount : this.taxReturn.amendmentCount + 1;
    if (this.configStateService.tenant === Tenant.ESS || this.configStateService.tenant === Tenant.HK || this.configStateService.tenant === Tenant.CN) {
      this.taxReturnService.waitingForPrep(this.taxReturn.id, { amendmentCount: count })
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(() => {
          this.completed.emit();
        });
    } else {
      this.taxReturnService.updateTaxReturnWithpreparer(this.taxReturn.id, { amendmentCount: count, revisionCount: this.taxReturn.revisionCount })
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(() => {
          this.completed.emit();
        });
    }
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.closed.emit();
  }

  private isAssignedToMe() {
    const assignedUser = this.taxReturn.assignedUser;
    return assignedUser && this.userInfo.id === assignedUser.id;
  }

  private hasPermission() {
    const reviewers: any[] = this.taxReturn.reviewer || [];
    return this.configStateService.tenant === Tenant.ESS || !reviewers.some(r => r.id === this.userInfo.id);
  }

}
